var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowToTop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 10,
    viewBox: "0 0 18 10",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.0002 9.00024C18.0002 8.74424 17.9023 8.48824 17.7073 8.29324L9.70725 0.293239C9.31625 -0.0977612 8.68425 -0.0977612 8.29325 0.293239L0.29325 8.29324C-0.09775 8.68424 -0.09775 9.31624 0.29325 9.70724C0.68425 10.0982 1.31625 10.0982 1.70725 9.70724L9.00025 2.41424L16.2932 9.70724C16.6842 10.0982 17.3162 10.0982 17.7073 9.70724C17.9023 9.51224 18.0002 9.25624 18.0002 9.00024Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowToTop);
export default __webpack_public_path__ + "static/media/arrowToTop.0f6c96be.svg";
export { ForwardRef as ReactComponent };